import { render, staticRenderFns } from "./setupModal.vue?vue&type=template&id=730d41dd&scoped=true"
import script from "./setupModal.vue?vue&type=script&lang=ts"
export * from "./setupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d41dd",
  null
  
)

export default component.exports